const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * ErrorReporting Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('ErrorReporting', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/v3/report-error/:subresource', null, {
    send: {params: {subresource: ''}, method: 'POST', isArray: false}
  });
}]);